<template>
  <div>
    <form>
      <CCard style="padding: 15px">
        <CCardBody>
          <div class="row">
            <div class="col">
              <div class="form-floating mb-3">
                <input
                  type="text"
                  v-model="user.brand"
                  class="form-control form-input"
                  placeholder="Service name"
                  autocomplete="off"
                  :class="{
                    'is-invalid': submittedotp && $v.user.brand.$error,
                  }"
                />
                <label for="floatingPassword">Service name</label>
                <div
                  v-if="submittedotp && !$v.otp.required"
                  class="invalid-feedback"
                >
                  Service name is required
                </div>
              </div>
            </div>
            <div class="col">
              <div class="form-floating mb-3">
                <input
                  type="text"
                  v-model="user.treatedFor"
                  class="form-control form-input"
                  id="floatingPassword"
                  placeholder="Treated for"
                  autocomplete="off"
                  :class="{
                    'is-invalid': submittedotp && $v.user.treatedFor.$error,
                  }"
                />
                <label for="floatingPassword">Treated for</label>
                <div
                  v-if="submittedotp && !$v.otp.required"
                  class="invalid-feedback"
                >
                  Treated for is required
                </div>
              </div>
            </div>
          </div>
          <div
            class="row"
            style="
              border-top: 1px solid gainsboro;
              margin-top: 10px;
              margin-bottom: 10px;
            "
          >
            <div class="col" style="padding-top: 10px; padding-bottom: 10px">
              <label>Treated By</label>
              <div v-for="(input, k) in inputs" :key="k">
                <CRow>
                  <CCol>
                    <div class="form-floating mb-3">
                      <input
                        type="text"
                        v-model="input.name"
                        class="form-control form-input"
                        id="floatingPassword"
                        placeholder="Treated by"
                        autocomplete="off"
                        :class="{
                          'is-invalid':
                            submittedotp && $v.user.treatedFor.$error,
                        }"
                      />
                      <label for="floatingPassword">Treated by</label>
                      <div
                        v-if="submittedotp && !$v.otp.required"
                        class="invalid-feedback"
                      >
                        Treated By is required
                      </div>
                    </div>
                  </CCol>

                  <CCol>
                    <i
                      class="fas fa-minus-circle"
                      @click="remove(k)"
                      v-show="k || (!k && inputs.length > 1)"
                      style="font-size: 20px; padding-top: 15px; color: #ff0000"
                    >
                    </i>
                    <i
                      class="fas fa-plus-circle"
                      @click="add(k)"
                      v-show="k == inputs.length - 1"
                      style="
                        font-size: 20px;
                        padding-top: 15px;
                        color: #ff0000;
                        padding-left: 5px;
                      "
                    >
                    </i>
                  </CCol>
                </CRow>
              </div>
            </div>
          </div>
          <div
            class="row"
            style="
              border-top: 1px solid gainsboro;
              padding-top: 10px;
              padding-bottom: 10px;
            "
          >
            <div class="col-4" style="margin-top: 1rem; margin-bottom: 1rem">
              <img
                :src="imageFileDisp"
                class="image-wrapper"
                v-if="imageFileDisp"
              />
              <img
                src="../../assets/product-default.svg"
                class="image-wrapper"
                style="border: 1px solid gainsboro"
                v-else
              />
            </div>
            <div class="col-8">
              <div style="padding-top: 25px">
                <CCard>
                  <CCardHeader> Upload Image </CCardHeader>
                  <CCardBody>
                    <div class="row">
                      <div class="col-8">
                        <label> Upload/change service image </label>

                        <input
                          type="file"
                          @change="onImageSelected"
                          accept="image/*"
                          class="form-control"
                        />
                      </div>
                      <div class="col">
                        <div
                          @click="deleteImage"
                          style="
                            background: gainsboro;
                            cursor: pointer;
                            border-radius: 3rem;
                            text-align: center;
                            padding-top: 4px;
                            padding-bottom: 4px;
                            margin-top: 2rem;
                            margon-bottom: 1rem;
                            border: 1px solid gainsboro;
                          "
                        >
                          <span> Delete </span>
                        </div>
                      </div>
                    </div>
                  </CCardBody>
                </CCard>
              </div>
            </div>
          </div>
          <div
            class="row"
            style="
              border-top: 1px solid gainsboro;
              padding-top: 10px;
              padding-bottom: 10px;
            "
          >
            <div class="col" style="margin: 10px 10px">
              <CCard>
                <CCardHeader>
                  <span style="font-size: 16px; color: #24282c">
                    Description
                  </span>
                </CCardHeader>
                <CCardBody>
                  <quill-editor
                    :content="user.description"
                    v-model="user.description"
                    style="
                      height: 100%;
                      margin-top: 10px;
                      margin-left: 10px;
                      margin-right: 10px;
                      margin-bottom: 10px;
                    "
                  />
                </CCardBody>
              </CCard>
            </div>
          </div>
          <CCardFooter>
            <b-button
              variant="danger"
              style="
                float: right;
                padding-right: 2rem;
                padding-left: 2rem;
                border-radius: 10rem;
              "
              @click="onSubmit"
            >
              Save & Submit
              <b-spinner v-if="serviceload" small type="grow"></b-spinner>
            </b-button>
          </CCardFooter>
        </CCardBody>
      </CCard>
    </form>
  </div>
</template>
<script>
import firebase from "firebase";
import { uuid } from "vue-uuid";
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import Vue from "vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  email,
  sameAs,
  helpers,
} from "vuelidate/lib/validators";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
Vue.use(VueToast, {
  // One of the options
  position: "top-right",
});
Vue.use(VueQuillEditor);
export default {
  components: {
    vSelect,
  },
  data() {
    return {
      user: {},
      inputs: [
        {
          name: "",
        },
      ],
      serviceload: false,
      isSubmit: false,
      selected: "",
      selected1: "",
      content: null,
      category: "",
      userId: "",
      uuidvalue: "",
      img1: "",
      baseimage: "",
      imageData: null,
      lab: null,
      labs: [],
      categoryOption: [],
      catalogOption: [],
      selectedoption: null,
      imageFileDisp: null,
      available: false,
    };
  },
  computed: {
    isValid() {
      return !this.$v.user.$invalid;
    },
    isDirty() {
      return this.$v.user.$anyDirty;
    },
  },
  mixins: [validationMixin],
  validations: {
    user: {
      name: {
        required,
        minLength: minLength(3),
      },
      brand: {
        required,
      },
      skucode: {
        required,
      },
      treatedFor: {
        required,
      },
      discount: {
        required,
      },
      barcode: { required },
      weight: {
        required,
      },
      description: {
        required,
      },
      selected: {
        required,
      },
      selected1: {
        required,
      },
      mrp: {
        required,
      },
    },
  },
  methods: {
    deleteImage() {
      this.imageFileDisp = false;
    },

    add() {
      this.inputs.push({
        name: "",
      });

      console.log(typeof this.inputs);
    },
    remove(index) {
      this.inputs.splice(index, 1);
    },
    checkIfValid(fieldName) {
      const field = this.$v.user[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    validate() {
      this.$v.$touch();
    },
    previewImage: function (event) {
      this.uploadValue = 0;
      this.img1 = null;
      this.imageData = event.target.files[0];
      this.uuidvalue = uuid.v1();
      this.onUpload();
    },
    onImageSelected(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createFileImage(files[0]);
      this.previewImage(e);
    },
    createFileImage(file) {
      var reader = new FileReader();
      var vm = this;
      reader.onload = (e) => {
        vm.imageFileDisp = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onUpload() {
      console.log("on Upload");
      this.img1 = null;
      const storageRef = firebase
        .storage()
        .ref(this.uuidvalue)
        .put(this.imageData);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            this.img1 = url;
            console.log("Probably stored", this.img1);
            return this.img1;
          });
        }
      );
    },
    onSubmit() {
      this.serviceload = true;
      console.log("user", this.user);
      console.log(this.img1);
      this.isSubmit = true;
      this.validate();
      const db = firebase.firestore();
      let ans = [];
      for (let i = 0; i < this.inputs.length; i++) {
        ans.push(this.inputs[i].name);
      }
      console.log(ans, "names");
      db.collection("service")
        .add({
          name: this.user.brand,
          //   rating:parseFloat(this.user.treatedFor * 0.750064) ,
          //  mrp: this.user.mrp,
          des: this.user.description,
          //   weight: this.user.weight,
          //    barcode:this.user.barcode,
          //   degrees: this.user.name,
          //   discount: this.user.discount,
          provide: this.user.treatedFor,
          photoUrl: this.img1,
          steps: [],
          "treated by": ans,
          //  catalog:this.user.selected1,
          id: firebase.auth().currentUser.uid,
          // featured: this.user.featured,
          // available: this.available
        })
        .then(() => {
          this.isSubmit = false;
          this.serviceload = true;
          Vue.$toast.success("Service added successfully!", {
            // override the global option
            position: "top-right",
          });

          this.$router.push("/services");
        })
        .catch((error) => {
          console.log(error);
          Vue.$toast.error(error.message, {
            // override the global option
            position: "top-right",
          });
        });
    },
    getCategoryList() {
      const db = firebase.firestore();

      console.log(firebase.auth().currentUser.uid);
      db.collection("service")

        .where("id", "==", firebase.auth().currentUser.uid)
        // .orderBy("category")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            console.log(doc.data().id, "category");
            this.categoryOption.push(doc.data().name);
          });
          console.log(this.categoryOption);
        });
    },
    getCatalogList() {
      let temp = [];
      const db = firebase.firestore();
      db.collection("catalog")
        .where("id", "==", firebase.auth().currentUser.uid)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            console.log("Catalog list", doc.data());
            this.catalogOption.push(doc.data().name);
          });
          // this.catalog = temp;
          console.log("Catalog", this.catalog);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created: function () {
    this.getCategoryList();
    this.getCatalogList();
  },
};
</script>
<style scoped>
.error {
  color: red;
}
.btncen {
  text-align: center;
}

.ifdre {
  height: 35% !important;
  padding-left: 2%;
  width: 10%;
  float: right;
  padding-bottom: 3%;
}
.image-wrapper {
  display: table-cell;
  width: 200px;
  height: 200px;
  vertical-align: middle;
}

.image-wrapper img {
  max-width: 100%;
  max-height: 100%;
  display: block;
  margin: 0 auto;
}

.custom-file {
  position: relative;
  margin-left: 1%;
  /* padding-left: 91px; */
  display: inline-block;
  width: 40%;
  height: calc(2.0625rem + 2px);
  margin-bottom: 5%;
}

textarea.form-control {
  height: 211%;
}
</style>
